<script lang="ts" setup>
export interface PagesFaqPageHeaderProps {
    title: string
    headingType: string
}

const props = defineProps<PagesFaqPageHeaderProps>()

const handleSearch = (value: string): void => {
    // get route
    const route = useNamedRoutes({
        name: 'search',
        query: {
            q: value,
            filter: 'faq',
            all_categories: 'false',
        },
    })
    // redirect to the route
    window.location.href = route
}
</script>
<template>
  <ContainerFluid class="py-12 py-md-20 border-bottom">
    <PageHeaderSearch
      :title="props.title"
      :heading-type="props.headingType"
      :action="useNamedRoutes({ name: 'faq' })"
      @submit="handleSearch"
    />
  </ContainerFluid>
</template>
